import { authUrl } from '@/api/types';

export function loginUrl() {
  return `${authUrl}/login`;
}

export function logoutUrl() {
  return '/auth/logout';
}
